import React, { FC } from 'react';
import ProductAddOn from './ProductAddOn';
import { getLocaleInfo } from '@/utils/helpers';
import { ProductAddOnsProps, calculateCartTotal, getCartList } from './utils';
import useLocale from '@/hooks/useLocale';
import { ExtendedProductFields } from '@/core/contentfulConfig';

const ProductAddOns: FC<ProductAddOnsProps> = ({
  productAddOns,
  selectedAddOns,
  setSelectedAddOns,
  productFields,
  defaultVariant,
}) => {
  const { productAddOnsTitle, productAddOnsTotalLabel } = productFields;
  const locale = useLocale();
  const { browserLocale } = getLocaleInfo(locale);

  const calculatedTotal = calculateCartTotal(
    defaultVariant,
    selectedAddOns,
    browserLocale,
  );
  const cartList = getCartList(productFields.title, selectedAddOns);

  return (
    <div className="mb-3 mt-4">
      {productAddOnsTitle && (
        <p className="mb-4 text-lg font-bold md:text-base">
          {productAddOnsTitle}
        </p>
      )}
      <ul>
        {productAddOns?.map((productAddOn) => {
          const shopifyProductAddOn = (
            productAddOn?.fields as ExtendedProductFields
          )?.shopifyProduct;

          return shopifyProductAddOn ? (
            <ProductAddOn
              key={productAddOn.sys.id}
              productAddOn={productAddOn}
              shopifyProductAddOn={shopifyProductAddOn}
              selectedAddOns={selectedAddOns}
              setSelectedAddOns={setSelectedAddOns}
            />
          ) : null;
        })}
      </ul>
      {productAddOnsTotalLabel && (
        <p className="font-bold">
          {productFields.productAddOnsTotalLabel} {calculatedTotal}
        </p>
      )}
      <p>{cartList}</p>
    </div>
  );
};

export default React.memo(ProductAddOns);
